import React from "react";

const OnboardContext = React.createContext({
  step: 0,
  goForward: () => {},
  goBack: () => {},
  plans: [],
  setSelectedPlan: () => {},
  credential: {},
  currentPlan: undefined,
});

export default OnboardContext;
